export default "__VITE_ASSET__D_0HzgAW__"